import { createFileRoute } from '@tanstack/react-router';

import { StudentPortalProfile } from '@/features/student-portal/StudentPortalProfile';

export const Route = createFileRoute('/student-portal/$contactId')({
  component: StudentPortalProfile,
});
